import { Flex, Icon, Text } from '@inflearn/ds-react-next';
import { faBook } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

export const NoteCount = ({ count }: { count: number }) => {
  const { t } = useTranslation();

  return (
    <Flex gap={4} align="center">
      <Icon icon={faBook} color="infgreen.7" width={9} height={10} />
      <Text fz={14} c="infgreen.7">
        {t('노트 {{noteCount}}', { count, noteCount: count.toLocaleString() })}
      </Text>
    </Flex>
  );
};
